<!-- Footer -->
<section class="footer-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <!-- Logo & Description -->
            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget">
                    <div class="logo">
                        <a routerLink="/"><img src="assets/img/logo.png" width="200" alt="Logo ASESA" /></a>
                    </div>

                    <p>
                        <strong>ASESA</strong> (Aide pour la santé, l’éducation et le sport en Afrique) agit pour améliorer durablement
                        les conditions de vie des communautés à la base, en particulier dans les zones rurales les plus défavorisées.
                    </p>

                    <ul class="social-list">
                        <li><a href="#" target="_blank" rel="noopener"><i class="fab fa-facebook-f"></i></a></li>
                        <li><a href="#" target="_blank" rel="noopener"><i class="fab fa-instagram"></i></a></li>
                        <li><a href="#" target="_blank" rel="noopener"><i class="fab fa-linkedin-in"></i></a></li>
                        <li><a routerLink="/kontakt"><i class="fas fa-envelope"></i></a></li>
                    </ul>
                </div>
            </div>

            <!-- Navigation -->
            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Navigation</h3>
                    <ul class="list">
                        <li><a routerLink="/ueber-uns">À propos</a></li>
                        <li><a routerLink="/team">L’équipe</a></li>
                        <li><a routerLink="/kontakt">Contact</a></li>
                    </ul>
                </div>
            </div>

            <!-- Devise / Disponibilité -->
            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Notre devise</h3>
                    <p>« Agir ensemble pour des communautés en meilleure santé, mieux éduquées et plus résilientes. »</p>

                    <h4 class="mt-4">Disponibilité</h4>
                    <ul class="list">
                        <li>Lundi – Vendredi : 09:00 – 17:00</li>
                        <li>Samedi : sur rendez-vous</li>
                        <li>Dimanche : fermé</li>
                    </ul>
                </div>
            </div>

            <!-- Contact -->
            <div class="col-lg-3 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Contact</h3>
                    <ul class="list">
                        <li>
                            <strong>Siège :</strong><br>
                            Morétan, Rue Okpoguédjé<br>
                            Commune Est-Mono 2 (Togo)
                        </li>
                        <li class="mt-2">
                            <strong>Téléphone :</strong><br>
                            <a href="https://wa.me/22891181292" target="_blank" rel="noopener">+228 91 18 12 92 (WhatsApp)</a>
                        </li>
                        <li class="mt-2">
                            <strong>Contact :</strong><br>
                            <a routerLink="/kontakt">Formulaire de contact</a>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</section>

<!-- Copyright -->
<div class="copy-right">
    <div class="container">
        <div class="copy-right-content text-center">
            <p>
                © 2025 ASESA – Tous droits réservés. <br>
                Site réalisé par <a href="https://geekinstitut.com" target="_blank" rel="noopener">Geek Institut</a>
            </p>
        </div>
    </div>
</div>

<!-- Go to Top -->
<div class="go-top">
    <i class="fa fa-chevron-up"></i>
    <i class="fa fa-chevron-up"></i>
</div>
